const initialState = {
    doctor: [],
    patient:[],
    
  };
  
  const APaymentsReducers = (state = initialState, action: any) => {
    switch (action.type) {
      case 'fetch_Doctor_success':
        return { ...state, doctor: action.payload };
        case 'fetch_Patient_success':
            return { ...state, patient: action.payload };
           
        
      
    

      default:
        return state;
    }
  };
  
  export default APaymentsReducers;
  
  